import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=32281556&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=32281556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32281556",
  null
  
)

export default component.exports